export default {
  method_unavailable: 'Tämä maksutapa ei ole juuri nyt käytettävissä. Valitse toinen.',
  payment_option_unavailable: 'Tämä maksuvaihtoehto ei ole juuri nyt käytettävissä. Valitse toinen maksutapa.',
  online_payment_unavailable: 'Verkkomaksu ei ole juuri nyt käytettävissä. Yritä hetken kuluttua uudelleen.',
  retry_payment_methods: 'Yritä uudelleen',
  payment_not_ready: 'Maksuasi vielä valmistellaan. Yritä hetken kuluttua uudelleen.',
  wallet_total_changed: 'Tämän maksutavan kokonaissumma on muuttunut. Tarkista se ja napauta painiketta uudelleen.',
  wallet_tap_above: 'Napauta yllä olevaa {{method}}-painiketta maksaaksesi tai valitse toinen maksutapa.',
  wallet_pay_above: 'Käytä yllä olevaa {{method}}-painiketta',
  element_incomplete: 'Täytä maksutietosi jatkaaksesi.',
  element_incomplete_card: 'Tarkista korttitietosi ja yritä uudelleen.',
  element_incomplete_bank: 'Valitse pankkisi jatkaaksesi.',
  element_incomplete_sepa_debit: 'Tarkista IBAN ja tilinhaltijan tiedot jatkaaksesi.',
};
